import { ReactNode, startTransition, useState } from "react";
import { isAndroid, isIOS } from "react-device-detect";
import { matchPath } from "react-router-dom";
import {
  ROLE_PERMISSIONS_FLATTEN,
  ROUTE_PATH_NAME_BY_ID
} from "../../../../helpers/permissionConstant";
import MobileAppPrompt from "./MobileAppPrompt";

const GOFFICE_DOWNLOAD_URL = process.env.REACT_APP_GOFFICE_DOWNLOAD_URL || "";

const DIGITS_ONLY = /^\d+$/;

function isTaskId(id?: string | null): boolean {
  return !!id && DIGITS_ONLY.test(id) && Number(id) > 0;
}

/**
 * Link Chi tiết nhiệm vụ mà app G-Office mở được (GPMS-5347), cùng điều kiện với
 * app: G-Ticket `/gticket/work-list/detail?id=<số>`, G-Process `/g-process/my-mission/<số>`.
 */
function isTaskDetailLink({ pathname, search }: Location): boolean {
  const { G_TICKET } = ROLE_PERMISSIONS_FLATTEN;
  if (pathname === ROUTE_PATH_NAME_BY_ID[G_TICKET.TASK_DETAIL]) {
    return isTaskId(new URLSearchParams(search).get("id"));
  }
  const gProcessTask = matchPath(
    {
      path: ROUTE_PATH_NAME_BY_ID.G_PROCESS_DETAIL_MY_TASK,
      caseSensitive: true
    },
    pathname
  );
  return isTaskId(gProcessTask?.params.id);
}

export function shouldShowMobileAppPrompt(location: Location): boolean {
  return (
    !!GOFFICE_DOWNLOAD_URL && (isAndroid || isIOS) && isTaskDetailLink(location)
  );
}

/**
 * Mở link Chi tiết nhiệm vụ trên điện thoại thì mời cài G-Office trước khi chạy App
 * (chưa kiểm tra đăng nhập SSO). "Để sau" thì chạy App như hiện nay.
 */
function MobileAppPromptGate({ children }: { children: ReactNode }) {
  const [showPrompt, setShowPrompt] = useState(() =>
    shouldShowMobileAppPrompt(window.location)
  );

  if (!showPrompt) return <>{children}</>;

  return (
    <MobileAppPrompt
      downloadUrl={GOFFICE_DOWNLOAD_URL}
      // App render LoadingFallback → Layout lazy Header/Sidebar mà không có Suspense bọc ngoài:
      // mount App từ click phải là transition, nếu không React báo lỗi #426.
      onLater={() => startTransition(() => setShowPrompt(false))}
    />
  );
}

export default MobileAppPromptGate;
